import type { SpaceProps as AntdSpaceProps } from 'antd'
import { Space as AntdSpace } from 'antd'
import { type ReactNode } from 'react'

import styles from './styles.scss'

// SIZES
// Small -> 8px (.5rem)
// Middle -> 16px (1rem)
// Large -> 24px (1.5rem)
export interface SpaceProps extends AntdSpaceProps {
  children: ReactNode
  direction?: 'horizontal' | 'vertical'
  size?: AntdSpaceProps['size']
  wrap?: boolean
}

export function Space({
  children,
  size = 'small',
  direction = 'horizontal',
  wrap,
  ...props
}: SpaceProps) {
  const wrapClassname = wrap ? styles.wrap : ''
  return (
    <AntdSpace
      {...props}
      className={[styles.space, wrapClassname, props.className].join(' ')}
      direction={direction}
      size={size}
    >
      {children}
    </AntdSpace>
  )
}
